// Attribution for the landing-page experiment. Never gate authentication on analytics.
const KEY = 'et_lp_v1';
const MEASUREMENT_ID = 'G-8HQZHFXRV9';
const WINDOW_MS = 7 * 86400000;
let configured = false;
let converted = false;
let preview = false;

const isProduction = () => typeof window !== 'undefined' &&
  window.location.hostname === 'app.embroiderytrace.com';

export function validLandingAssignment(value, now = Date.now()) {
  return !!(value && value.id === KEY && ['A', 'B'].includes(value.variant) &&
    Number.isFinite(value.enrolledAt) && value.enrolledAt <= now &&
    now - value.enrolledAt <= WINDOW_MS);
}

export function captureLandingExperiment() {
  if (!isProduction()) return;
  try {
    const params = new URLSearchParams(window.location.search);
    preview = params.get('et_preview') === '1' || sessionStorage.getItem(`${KEY}_preview`) === '1';
    if (preview) {
      sessionStorage.setItem(`${KEY}_preview`, '1');
      return;
    }
    const cookie = document.cookie.split('; ').find(item => item.startsWith(`${KEY}=`));
    const existing = cookie ? JSON.parse(decodeURIComponent(cookie.slice(KEY.length + 1))) : JSON.parse(localStorage.getItem(KEY));
    if (validLandingAssignment(existing)) { localStorage.setItem(KEY, JSON.stringify(existing)); return; } // First assignment wins across tabs and OAuth.
    const incoming = {
      id: params.get('et_exp'),
      variant: params.get('et_variant'),
      enrolledAt: Number(params.get('et_enrolled')),
    };
    if (validLandingAssignment(incoming)) localStorage.setItem(KEY, JSON.stringify(incoming));
  } catch (_) { /* Missing storage must not interrupt signup. */ }
}

export function getLandingExperiment() {
  if (!isProduction() || preview) return null;
  try {
    if (sessionStorage.getItem(`${KEY}_preview`) === '1') return null;
    const value = JSON.parse(localStorage.getItem(KEY));
    return validLandingAssignment(value) ? value : null;
  } catch (_) { return null; }
}

export function trackLandingAccountCreated() {
  const assignment = getLandingExperiment();
  if (!assignment || converted) return;
  try {
    if (localStorage.getItem(`${KEY}_converted`)) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    if (!configured) {
      // Same marketing property on both subdomains. Do not send app pageviews to it.
      window.gtag('js', new Date());
      window.gtag('config', MEASUREMENT_ID, { send_page_view: false });
      if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
        document.head.appendChild(script);
      }
      configured = true;
    }
    window.gtag('event', `${KEY}_${assignment.variant.toLowerCase()}_signup`, {
      send_to: MEASUREMENT_ID,
      experiment_id: KEY,
      experiment_variant: assignment.variant,
    });
    converted = true;
    localStorage.setItem(`${KEY}_converted`, '1');
  } catch (_) { /* Analytics must never turn successful authentication into an error. */ }
}
